var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 128,
    fill: "#F1F3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 142c0-5.525 4.475-10 10-10h36c5.525 0 10 4.475 10 10v36c0 5.525-4.475 10-10 10h-36c-5.525 0-10-4.475-10-10v-36Z",
    fill: "#91A3C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136 64c2.8 0 5.425 1.475 6.85 3.885l24 39.99c1.5 2.475 1.525 5.55.1 8.075-1.4 2.5-4.075 3.825-6.95 3.825h-48c-2.875 0-5.55-1.325-6.95-3.825-1.425-2.525-1.4-5.6.1-8.075l24-39.99C130.575 65.475 133.2 64 136 64Zm-72 96c0-17.675 14.328-32 32-32 17.675 0 32 14.325 32 32s-14.325 32-32 32c-17.672 0-32-14.325-32-32Z",
    fill: "#B8C3D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 64h128v128H64z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/Nodata.b1b9feb9564bbcb52c18bf544544bc54.svg";
export { ForwardRef as ReactComponent };